import {
  CarPdfTable,
  CarPdfTableProps,
  CarPdfHeader,
  CarPdfHeaderCell,
  CarPdfRow,
  CarPdfTextCell,
} from "@app/components/PdfTable";
import { IndexCompareItem } from "@app/components/ChartIndexCompare";
import { getIndexCompareTable } from "@app/components/TableIndexCompare";
import {
  excelTableFormatValue,
  ExcelDataFormat,
} from "@app/hooks/useExcelExport";

interface IndexCompareSummaryPdfTableProps
  extends Omit<CarPdfTableProps, "children" | "colWidths"> {
  item1?: IndexCompareItem;
  item2?: IndexCompareItem;
  item3?: IndexCompareItem;
}

export const IndexCompareSummaryPdfTable = ({
  item1,
  item2,
  item3,
  ...props
}: IndexCompareSummaryPdfTableProps) => {
  const table = getIndexCompareTable({ item1, item2, item3 });

  return (
    <CarPdfTable
      colWidths={table.columns.map((i, idx) => (idx === 0 ? 1.3 : 1))}
      isRounded
      isStriped
      {...props}
    >
      <CarPdfHeader paddingVertical={8} key="header">
        {table.columns.map((i, idx) => (
          <CarPdfHeaderCell key={idx}>{i.label}</CarPdfHeaderCell>
        ))}
      </CarPdfHeader>
      {table.rows.map((row, rowIdx) => (
        <CarPdfRow key={rowIdx} paddingVertical={8}>
          {row.map((value, valueIdx) => (
            <CarPdfTextCell
              key={valueIdx}
              style={{
                textAlign:
                  table.columns[valueIdx].format === ExcelDataFormat.general
                    ? "left"
                    : "center",
                paddingHorizontal: 15,
              }}
            >
              {excelTableFormatValue(value, table.columns[valueIdx])}
            </CarPdfTextCell>
          ))}
        </CarPdfRow>
      ))}
    </CarPdfTable>
  );
};
